const MAX_PERMIT_SPAN_HOURS = 12;

/**
 * Duration between HH:mm (or HH:mm:ss) times, in hours.
 * Overnight windows (11 PM–12 AM) wrap past midnight.
 */
export function calcHoursDiff(start, end) {
  if (!start || !end) return null;
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  let diffMinutes = eh * 60 + (em || 0) - (sh * 60 + (sm || 0));
  if (diffMinutes < 0) {
    diffMinutes += 24 * 60;
  }
  const diff = diffMinutes / 60;
  if (!Number.isFinite(diff) || diff <= 0 || diff > MAX_PERMIT_SPAN_HOURS) {
    return null;
  }
  return diff;
}
